export const CATEGORIES = [
  {
    tag: "uitje",
    name: "Uitje",
    icon: "attractions"
  },
  {
    tag: "sport",
    name: "Sport",
    icon: "sports_tennis"
  },
  {
    tag: "feest",
    name: "Feest",
    icon: "celebration"
  },
  {
    tag: "vakantie",
    name: "Vakantie",
    icon: "beach_access"
  },
  {
    tag: "doen",
    name: "Doen",
    icon: "handyman"
  },
  {
    tag: "overig",
    name: "Overig",
    icon: "calendar_month"
  }
];

export const CATEGORY_MAP: Record<string, string> =
  CATEGORIES.reduce((acc, cat) => {
    acc[cat.tag] = cat.icon;
    return acc;
  }, {} as Record<string, string>);
